export default __webpack_public_path__ + "static/media/Hunter.02a15cba.jpg";